import styled from '@xstyled/styled-components'

import { Heading } from '@/components/Heading'

export const Container = styled.div<{ padding: string }>`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.padding};
  opacity: 0;
`

/* TODO: Use SEO friendly elements */
export const PreTitle = styled.span`
  clip-path: inset(13% 0 13% 0);
  font-size: md;
  font-weight: bold;
  margin-bottom: 1rem;
  overflow: hidden;
  span {
    display: block;
  }
`

export const Title = styled(Heading)`
  margin-bottom: 3.4rem;
  text-transform: uppercase;
  word-break: break-word;
  hyphens: auto;

  .line {
    margin-bottom: -2rem;
    overflow: hidden;
    padding-top: 0.4rem;
  }
`

/* TODO: Make dynamic for all elements, change back to p */
export const Paragraph = styled.p`
  display: block;
  font-size: md;
  line-height: 28px;
  margin-bottom: 3vw;
`

export const MobileNavigationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  a {
    max-width: 80%;
  }
`
